import React, { useMemo } from 'react';
import { useStyletron } from 'baseui';
import { computeContainFitBox } from '../../../labelling-v2/hooks/skeleton-template-builder/utils';
import { PREVIEW } from '../../constants/template-builder';
import type { SkeletonTemplateEdgeT, SkeletonTemplateNodeT } from '../../types/annotations.type';
import { SKELETON_PREVIEW_STYLE } from '../annotations/skeleton/constants';
import { NodeLabels } from '../annotations/skeleton/node-labels';
import { PreviewEdges } from '../annotations/skeleton/templates/preview-edges';
import { PreviewNodes } from '../annotations/skeleton/templates/preview-nodes';
import { fitSkeletonTemplateToBox } from '../annotations/skeleton/util';
type SkeletonTemplatePreviewPropsT = {
  nodes: ReadonlyArray<SkeletonTemplateNodeT>;
  edges: ReadonlyArray<SkeletonTemplateEdgeT>;
  aspectRatio: number;
  width?: number;
  height?: number;
};
export function SkeletonTemplatePreview({
  nodes,
  edges,
  aspectRatio,
  width: containerWidth,
  height: containerHeight
}: SkeletonTemplatePreviewPropsT) {
  const [, theme] = useStyletron();
  const width = containerWidth ?? PREVIEW.DEFAULT_WIDTH;
  const height = containerHeight ?? PREVIEW.DEFAULT_HEIGHT;
  const skeleton = useMemo(() => {
    const box = computeContainFitBox(width, height, aspectRatio || 1, PREVIEW.PADDING);
    return fitSkeletonTemplateToBox({
      id: 'preview',
      name: 'preview',
      nodes: [...nodes],
      edges: [...edges],
      aspectRatio
    }, box);
  }, [nodes, edges, aspectRatio, width, height]);
  const style = {
    strokeColor: SKELETON_PREVIEW_STYLE.DEFAULT_COLOR,
    strokeWidth: 2
  };
  return <svg width={width} height={height} data-testid="skeleton-template-preview">
      <PreviewEdges edges={skeleton.edges} nodes={skeleton.nodes} style={style} />
      <PreviewNodes nodes={skeleton.nodes} style={style} />
      <NodeLabels nodes={skeleton.nodes} color={theme.colors.contentPrimary} />
    </svg>;
}